import { render, staticRenderFns } from "./StartChecklist.vue?vue&type=template&id=05b1d19f&scoped=true&"
import script from "./StartChecklist.vue?vue&type=script&lang=js&"
export * from "./StartChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b1d19f",
  null
  
)

export default component.exports